import Vue from "vue";
import App from "./App.vue";
import VueAxios from "vue-axios";
import axios from "axios";

import "./registerServiceWorker";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import routes from "./routes";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { store } from "./store";
import VueEditableGrid from "vue-editable-grid";
import "vue-editable-grid/dist/VueEditableGrid.css";
import Auth0Authenticate from "./callia-auth0-authenticate";
import CalliaAxio from "./callia-axios";
import TooltipModal from "./components/tooltip-modal.vue";

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        default:
          console.log(`connection error ${error.response.status}`);
      }
    } else {
      console.log("error: ", error);
    }
    return Promise.resolve(error.response);
  }
);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueEditableGrid);
Vue.use(VueAxios, axios);
Vue.use(Auth0Authenticate, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: `${window.location.origin}`,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  scope: "openid profile email",
  cacheLocation: "localstorage",
  logoutRedirectUri: `${window.location.origin}`
});
Vue.component("tooltip-modal", TooltipModal);
Vue.use(CalliaAxio, axios, true);
Vue.config.productionTip = false;
const router = routes;
export const eventBus = new Vue({
  methods: {
    hideLeftMenu(isHide) {
      this.$emit("hideLeftMenuEvent", isHide);
    }
  }
});

// Initialize Auth0 and mount app
(async () => {
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  });

  // Initialize Auth0 client
  await app.$auth.init();

  app.$mount("#app");
})();
